import { getAccessToken, triggerReauth } from './AuthProvider';

// Drop-in replacement for fetch() that attaches the Cognito access token.
// Only for calls to our own backends — never use this for direct S3
// presigned-URL uploads, which carry their own query-string signature.
export async function apiFetch(url, options = {}) {
  const token = await getAccessToken();
  const headers = {
    ...options.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    // The one reliable signal that the session is actually over (vs. a
    // transient renewal hiccup, see AuthProvider.js). Redirect to login
    // instead of letting each of the 15 call sites surface this as a
    // generic, confusing error. The page is about to navigate away, so
    // return a promise that never resolves rather than the 401 response —
    // callers' .then()/await simply never completes, which is harmless
    // since the navigation tears down this JS context anyway.
    triggerReauth();
    return new Promise(() => {});
  }

  return response;
}
